var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-dialog",
    {
      attrs: {
        size: "md",
        okFn: function() {
          _vm.updateLastHealthReminder(true)
        },
        cancelFn: _vm.updateLastHealthReminder,
        keepOpened: "",
        okBtnText: _vm.$t("save"),
        hideFooter: _vm.variables.length === 1
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _vm.showTitle
        ? _c(
            "b-alert",
            { staticClass: "mb-4", attrs: { variant: "secondary", show: "" } },
            [_vm._v(_vm._s(_vm.$t("health-sliders-modal-explanation")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.additionalVariables, function(item, propName) {
        return _c(
          "div",
          { key: propName },
          [
            _vm.variables.includes(item.variableName)
              ? _c("clinic-history-variable", {
                  ref: "var-" + propName,
                  refInFor: true,
                  staticClass: "mb-2",
                  attrs: {
                    rawData: item,
                    name: propName,
                    value: [5],
                    variableName: item.variableName,
                    editable: "",
                    slider: "",
                    graphEnabled: false,
                    label: _vm.$t("health-slider-label." + propName),
                    hideDate: "",
                    verticalMode: "",
                    saveOnChange: false,
                    daily: "",
                    centered: propName == _vm.HEALTH_CONDITION_TODAY,
                    showTrackingButton: false
                  },
                  on: { save: _vm.onVariableSave }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.showTitle && propName == _vm.HEALTH_CONDITION_TODAY,
                    expression:
                      "showTitle && propName == HEALTH_CONDITION_TODAY"
                  }
                ]
              },
              [
                _c("hr"),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("health-sliders-modal-last-7-days")) +
                      "\n\t\t\t"
                  )
                ])
              ]
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2faf8fef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2faf8fef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/shared/HealthSlidersModal.vue
// module id = 3771
// module chunks = 38